import { UseDrillDownMenu } from "@/components/root/drilldown-menu/drilldown-menu.state";
import router from "@/router";
import MenuRow from "./MenuRow.vue";
import { SharedState } from "@/common/state";

export const show_dd_configure_menu = async (ev: MouseEvent) => {
  const menu = [
    {
      available: SharedState.is_sys_user.value,
      is_licensed: true,
      name: "Data Sources",
      desc: "View and manage your data sources",
      icon: "DataSource",
      isCategory: false,
      isPremium: false,
      subItems: [],
      action: () =>
        router().push({
          name: "DataSourceManagement",
        }),
    },
    {
      available: true,
      is_licensed: true,
      name: "Information Customization",
      desc: "Manage Sensitivity & Risk",
      icon: "Label",
      isCategory: false,
      isPremium: false,
      subItems: [],
      action: () => {
        if (
          SharedState.restrictions.is_restricted_app(
            "info_type_customization"
          ) &&
          SharedState.restrictions.is_restricted_app("risk_type_customization")
        ) {
          SharedState.restrictions.show_restrictions_modal(
            "app",
            "Information & Risk Type customization"
          );
          return;
        }
        router().push({
          name: "InformationCustomization",
        });
      },
    },

    {
      available: true,
      is_licensed: true,
      name: "Trust Management",
      desc: "View and manage contacts trust",
      icon: "User",
      isCategory: false,
      isPremium: false,
      subItems: [],
      action: () => {
        if (SharedState.restrictions.is_restricted_app("trust_management")) {
          SharedState.restrictions.show_restrictions_modal(
            "app",
            "entities trust management"
          );
          return;
        }
        router().push({
          name: "TrustManagement",
        });
      },
    },
    {
      available: true,
      is_licensed: SharedState.FeatureHelper.is_enabled("auto_mip_labeling"),
      name: "Automate Microsoft Labeling",
      desc: "Automate Microsoft-native file labeling",
      icon: "Ms",
      isCategory: false,
      isPremium: false,
      subItems: [],
      action: () => {
        SharedState.ifUserEnabledFeature(
          "auto_mip_labeling",
          () => {
            if (
              SharedState.restrictions.is_restricted_app("microsoft_labeling")
            ) {
              SharedState.restrictions.show_restrictions_modal(
                "app",
                "Microsoft Labeling"
              );
              return;
            }
            router().push({
              name: "MIP",
            });
          },
          { premium_modal_key: "automatemicrosoftlabeling-popup-2024" }
        );
      },
    },
    {
      /*
       * Google Drive labeling. Sibling of the Microsoft entry above and gated
       * on its own flag alone: neither flag surfaces the other's entry, and
       * with both on both rows appear.
       *
       * `available` rather than `is_licensed` because this is a rollout switch,
       * not a plan tier — the row should be absent when the flag is off, not
       * present with an upsell badge the way the Microsoft row is.
       *
       * Both entries lead to the same mapping screen with the provider
       * switched; see views/customize/mip/data/provider.ts.
       */
      available: SharedState.FeatureHelper.is_enabled("auto_gdrive_labeling"),
      is_licensed: true,
      name: "Automate Google Labeling",
      desc: "Automate Google Drive file labeling",
      // monochrome brand mark from icons/SourceIcons.vue, matching "Ms" above
      icon: "Gdrive",
      isCategory: false,
      isPremium: false,
      subItems: [],
      action: () => {
        router().push({
          name: "GoogleLabeling",
        });
      },
    },
    {
      available: SharedState.is_sys_user.value,
      is_licensed: SharedState.FeatureHelper.is_enabled(
        "justification_automation"
      ),
      name: "Policies",
      desc: "Policy customization & user event auditing",
      icon: "File",
      isCategory: false,
      isPremium: false,
      subItems: [],
      action: () => {
        SharedState.ifUserEnabledFeature(
          "justification_automation",
          () => {
            router().push({
              name: "InMotionCustomization",
            });
          },
          { premium_modal_key: "securitypolicies-popup-2024" }
        );
      },
    },
  ].filter((f) => f.available);

  const res = await UseDrillDownMenu().show({
    event: ev,
    // @ts-ignore
    menu,
    cmp: MenuRow,
  });
  if (res.didUserSelectedAnAction) {
    if (typeof res.actionSelected === "string") {
      router().push({ name: res.actionSelected });
    } else {
      (res.actionSelected as Function)();
    }
  }
};
